<script>
    export let place
    export let latest    = false

    $: items = [
        { header: "Nome"         , description: place.name        },
        { header: "Identificador", description: place.identifier  },
        { header: "Descrição"    , description: place.description },
        { header: "Responsável"  , description: place.responsible },
        { header: "Email"        , description: place.email       },
    ]

</script>
<style>
</style>

<h2 class="ui header">Informações</h2>
<div class="ui big list">
    {#each items as item}
      <div class="item">
        <div class="content">
            <div class="header">{item.header}</div>
            <div class="description">{item.description || '--'}</div>
        </div>
      </div>
    {/each}
</div>
